import { useMoralis } from 'react-moralis';
import SuperfluidSDK from '@superfluid-finance/js-sdk';
import { createContext, useContext, useEffect, useState } from 'react';

const SuperfluidContext = createContext();

export const SuperfluidProvider = ({ children }) => {
  const [superfluid, setSuperfluid] = useState(null);
  const { user, isWeb3Enabled, web3 } = useMoralis();

  useEffect(() => {
    (async () => {
      if (user && isWeb3Enabled && !superfluid) {
        const sf = new SuperfluidSDK.Framework({
          web3,
          version: 'v1',
        });

        await sf.initialize();

        setSuperfluid(sf);
      } else if (!user && superfluid) {
        setSuperfluid(null);
      }
    })().catch((err) => console.log(err));
  }, [superfluid, web3, isWeb3Enabled, user]);

  return (
    <SuperfluidContext.Provider value={superfluid}>
      {children}
    </SuperfluidContext.Provider>
  );
};

const useSuperfluid = () => useContext(SuperfluidContext);

export default useSuperfluid;
